import Vue from 'vue'
import Vuex from 'vuex'
import OfflineStorage from '../utils/offlineStorage'
import router from '../router'
import auth from '../utils/auth'
import graphApi from '../api/graphApi'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
    isOnline: navigator.onLine,
    settings: {},
    userProfile: null
  },
  getters: {
  },
  mutations: {
    REPLACE_STATE_PROP: (state, payload) => {
      state[payload.property] = payload.data;
    }
  },
  actions: {
    async initializeStore(context) {
      // Get Settings
      let settings = await OfflineStorage.getItem("settings");
      if (settings == null) {
        settings = {
          isDarkMode: false,
        };
        await OfflineStorage.setItem("settings", settings);
      }
      context.commit("REPLACE_STATE_PROP", { property: 'settings', data: settings });

      // Get User Profile
      let userProfile = await OfflineStorage.getItem('userProfile');
      if (!context.state.isOnline && userProfile != null) {
        context.commit("REPLACE_STATE_PROP", { property: "userProfile", data: userProfile });

        if (router.currentRoute && router.currentRoute.path !== '/') {
          router.push({ path: '/' });
        }
        return;
      }

      const response = await auth.ssoSilent();
      if (response) {
        context.commit("REPLACE_STATE_PROP", { property: "isAuthenticated", data: true });
        setUserProfile(context);
      }
    },
    async storeSignIn(context) {
      await auth.signIn();

      context.commit("REPLACE_STATE_PROP", { property: "isAuthenticated", data: true });
      
      setUserProfile(context);

      if (router.currentRoute.path !== '/') {
        router.push({ path: '/' });
      }
    },
    async storeSignOut(context) {
      auth.signOut();

      context.commit("REPLACE_STATE_PROP", { property: "userProfile", data: null });
      context.commit("REPLACE_STATE_PROP", { property: "isAuthenticated", data: false });

      await OfflineStorage.setItem('userProfile', null);

      if (router.currentRoute.path !== '/signin') {
        router.push({ path: '/signin' });
      }
    },
    async setOnlineStatusInStore(context, isOnline) { 
      context.commit('REPLACE_STATE_PROP', { property: 'isOnline', data: isOnline });
      if (isOnline && 
        !context.state.isAuthenticated) {
          await auth.ssoSilent(context);
      }
    },
    updateSettingsInStore(context, settings) { 
      context.commit('REPLACE_STATE_PROP', { property: 'settings', data: settings });
      OfflineStorage.setItem('settings', settings);
    },
  },
  modules: {
  }
})

async function setUserProfile(context) {
  const userProfile = await graphApi.getUserProfile();
  if (userProfile) {
    context.commit("REPLACE_STATE_PROP", { property: "userProfile", data: userProfile });
    await OfflineStorage.setItem('userProfile', userProfile);
  } else {
    context.commit("REPLACE_STATE_PROP", { property: "userProfile", data: null });
    await OfflineStorage.setItem('userProfile', null);
  }
}